<template>
    <span>
        <TInput :value="value" @input.stop="$emit('input', $event.target.value)"></TInput>
    </span>
</template>
<script>
import { TInput } from '@roonlabs/vue-tailwind'
export default {
    name: 'StringInput',
    components: {TInput},
    props: {
        value: String
    },
}
</script>
